import Slider from 'react-slider';

const ReactSlider = (props) => {
  return <Slider {...props} className={`comp-react-slider ${props.className || ''}`} />;
};

export default ReactSlider;
